import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import Keycloak from 'keycloak-js';
import { environment } from '../../../environments/environment';
import { IconComponent } from '../../shared/components/icon/icon.component';

@Component({
  selector: 'app-home',
  imports: [RouterLink, IconComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  registerAvailable = environment.registerAvailable;
  readonly bpUrl = environment.bpUrl;
  readonly year = new Date().getFullYear();

  constructor(
    private router: Router,
    private keycloak: Keycloak
  ) {}

  ngOnInit() {
    if (this.keycloak.authenticated) {
      this.router.navigate(['/dashboard']);
    }
  }

  agencyLogin(): void {
    this.keycloak.login({ redirectUri: window.location.origin });
  }
}
